import { useState } from 'react';
//import InputForm from '../../../InputT';
import InputForm from '../../InputT';
import { useTranslation } from 'react-i18next';
//import ParamsPicklist from '../../../../Types/ParamsPicklist';
import ParamsPicklist from '../../../Types/ParamsPicklist';
//import DataType from '../../../../Types/DataTablePiclist';
import DataType from '../../../Types/DataTablePiclist';
import { Backdrop, Box, CircularProgress, FormControl, InputLabel, MenuItem, Select, Tooltip } from '@mui/material';
//import SearchInput from '../../../SearchInput';
import SearchInput from '../../SearchInput';
//import SearchModal from '../../../SearchModal';
import SearchModal from '../../SearchModal';
import { ColumnsType } from 'antd/es/table';
import Table from '../../TableResizable';
import { MonetizationOnOutlined, AttachMoneyOutlined, NightShelterOutlined, BlockOutlined, AdminPanelSettingsOutlined, BookOnlineOutlined, Delete } from '@mui/icons-material';
//import Utilisateur from '../../../../Models/Utilisateur';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import SweetAlert from 'sweetalert2';
import axios from 'axios';
//import { Crypter } from '../../../../Functions/Security/Crypter';
import { Crypter } from '../../../Functions/Security/Crypter';
//import Data from '../../../Data/Data.json';
import Data from '../../../Data/Data.json'
//import data

//import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import formatNumber from '../../../Functions/Traitement/FormatNumber';
//import DataHistoCpt from '../../../../Types/DataHistoCpt';
import DataHistoCpt from '../../../Types/DataHistoCpt';
//import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import ReformatDate from '../../../Functions/Traitement/ReformatDate';
import { Badge, Button, Form, Input, Space } from 'antd';
//import SelectOption from '../../../SelectOption';
import SelectOption from '../../SelectOption';
//import DataSelect from '../../../../Types/DataSelect';
import DataSelect from '../../../Types/DataSelect';

import { Grid } from '@mui/material';
import InputFormMUI from '../../InputTMUI';
import SearchModalMUI from '../../SearchModalMUI';
import SelectOptionMUI from '../../SelectOptionMUI';

const Swal = require('sweetalert2');
let Link = require('../../../Data/Data.json');


const dataOption2: DataSelect[] = [
  { label: "D--DEBIT", value: "D" },
  { label: "C--CREDIT", value: "C" }
]


const Tab1 = (props: { etatG: boolean, form?: any, DataOperation: DataHistoCpt[], GetAllOperation: Function }) => {

  const datas: DataType[] = [];
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [Filtre, setFiltre] = useState<number>();
    const [Sens, setSens] = useState('');
    const [selected, setSelected] = useState('');
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  const authHeader = useAuthHeader();

  //Initialisation des parametres de recherche
  let searchRef: ParamsPicklist = { CodeAgence: user.codage, Table: "ECPTAMPON", Colonne1: "REPECE", Colonne2: "LIBELL", colfiltre:"UTISAI",valfiltre:user.coduti, Colagence: 'AEDUCP', Choix: 22 }
  let searchOp: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
  let searchCompte: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT",  Colagence: "", Choix: 22 }

  const columns: ColumnsType<DataHistoCpt> = [
    {
      title: 'Date Opération',
      dataIndex: 'DATOPE',
      ellipsis: true,
      width: 100,
      render: (text: any, reccord: any) => (
        <span>
          {ReformatDate(text)}
        </span>
      )
    },
    {
      title: 'Heure',
      dataIndex: 'TIME',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'N° Compte',
      dataIndex: 'NUMCPT',
      ellipsis: true,
      width: 200,
      // filteredValue: [SearchR],
      onFilter: (value: any, record: any) => {
        return String(record.NUMCPT)
          .toLowerCase()
          .includes(value.toLowerCase()) ||
          String(record.SENSEC)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.REPECE)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.MONTANT)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.LIBELL)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Utilis)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Motif)
            .toLowerCase()
            .includes(value.toLowerCase())
      }
    },
    {
      title: 'Sens',
      dataIndex: 'SENSEC',
      ellipsis: true,
      width: 100,
      align: 'center',
      render: (text: any, reccord: any) => (
        <Box sx={{ alignItems: 'center' }}  >
          <Badge status='success' color={reccord.SENSEC == "C" ? 'green' : reccord.SENSEC == "D" ? 'red' : 'orange'} size='default' count={reccord.SENSEC == "D" ? 'Debit' : reccord.SENSEC == "C" ? 'Credit' : 'No sence'}> </Badge>
        </Box>
      )
    },
    {
      title: 'Ref manuelle',
      dataIndex: 'REPECE',
      ellipsis: true,
      width: 200,
    },
    {
      title: 'REF Liaison',
      dataIndex: 'REFLIAI',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Numrap',
      dataIndex: 'NUMRAP',
      ellipsis: true,
      width: 100,
    }
    ,
    {
      title: 'Montant',
      dataIndex: 'MONTANT',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Beneficiare',
      dataIndex: 'NBENEF',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Utisai',
      dataIndex: 'UTISAI',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Action',
      key: 'action',
      ellipsis: true,
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title='Retirer de la liste'>
            <Button disabled={false} color='error' icon={<Delete color='error' />} onClick={() => {
              handleDeleOperation(record.REPECE, record.REFLIAI ? record.REFLIAI : '');
            }} />
          </Tooltip>
        </Space>
      ),
    },
    {
      title: 'Libelle',
      dataIndex: 'LIBELL',
      ellipsis: true,
      width: 200
    },
    {
      title: "",
      dataIndex: 'RelObject',
      width: 1
    }
  ];

  let informationclient = {
    SearchRef: {
      Titre: "Recherche Service",
      label: "Numéro Référence",
      name: "Reference", params: searchRef
    },
    searchCodeOpe: {
      Titre: "Recherche Opération",
      label: "Code opération",
      name: "CodeOpe", params: searchOp
    },
    searchCompte: {
      Titre: "Recherche Compte  ",
      label: "Numéro compte",
      name: "NUMCPT", params: searchCompte
    },
    //Montant disponible du compte à débité
    InputDisponible: {
      label: "Disponible",
      name: "DISPON"
    },
    //Montant disponible pour le recepteur
    InputBloque: {
      label: "Montant Bloqué",
      name: "BLOQUE"
    },
    InputAutori: {
      label: "Autorisation",
      name: "AUTORI"
    },
    //Montant disponible pour le recepteur
    InputVeille: {
      label: "Solde Veille",
      name: "SOLVEI"
    },
    InputTaux: {
      label: "Taux",
      name: "Taux"
    },
    InputMontant: {
      label: "Montant",
      name: "Montant"
    },
    InputNumPiece: {
      label: "N° Pièce",
      name: "Montant"
    }
  }



 

  const handleChangeCompte = async () => {

    setLoading(true);
    let NUMCPT = '';
    NUMCPT = props.form.getFieldValue('NUMCPT');
     
    let data = Crypter.encrypt(NUMCPT);

    props.form.setFieldsValue({ "lib_NUMCPT": '', 'DISPON': '', 'BLOQUE': '', 'SOLVEI': '', 'AUTORI': '', 'CDDEVS': 'XAF', 'lib_CDDEVS': '' })
    
  if(NUMCPT.length!=0)
  {

    let config1 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetCompte,
      headers: {
        'CypherNumCpte': data,
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };

    let config2 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Link.ApiUrl.GetGetCodeOperat,
      headers: {
        'CypherChampOpe': Crypter.encrypt('OPE009'),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };

    let requestOne = axios.request(config1);
    let requestTwo = axios.request(config2);

    await axios
      .all([requestOne, requestTwo])
      .then(
        await axios.spread(async (...responses: any) => {

          const responseOne = responses[0];
          const responseTwo = responses[1];
          if (responseOne.data) {
            const res = JSON.parse(Crypter.decrypt(responseOne.data));
            if (res.StatutCode == 200) {
              let datas = res.Result.Table[0];

              if (res.Result.Table.length > 0) {
                //alert(formatNumber(datas.DISPON))
                props.form.setFieldsValue({ 'lib_NUMCPT': datas.NOMCPT, 'DISPON': datas.DISPON, 'CDDEVS': datas.CDDEVS ||'XAF', 'lib_CDDEVS': datas.CDDEVS, 'SOLVEI': datas.SOLVEI, 'BLOQUE': datas.BLOQUE, 'AUTORI': datas.AUTORI });
                //Devise
              } else {
                SweetAlert.fire({ title: "Warning", text: "Compte not found", icon: "warning" })
              }

              if (responseTwo.data) {
                const res = JSON.parse(Crypter.decrypt(responseTwo.data)).Value;
                if (res.StatutCode == 200) {
                  let datas = res.Result[0];
                  props.form.setFieldValue("Libelle", datas.LIBELL + ' FAVEUR ' + props.form.getFieldValue("lib_NUMCPT"))
                }
                else {
                  setLoading(false);
                  SweetAlert.fire({ title: "error", text: res.Message, icon: "error" })
                }
              }
            }
            else {
              setLoading(false);
              SweetAlert.fire({ title: "error", text: res.Message, icon: "error" })
            }
          }
        }
        )).catch((errors) => {
          SweetAlert.fire({ title: "error", text: errors.message, icon: "error" })
        });
      }
      setLoading(false);
  }



  const handleDeleOperation = async (Reference: string, NUMRAP: string) => {
    setLoading(true);
    SweetAlert.fire({
      title: "Suppression d'opération",
      text: "Voulez-vous Supprimer les Opérations de réference : " + Reference + " ? ",
      showCancelButton: true,
      color: "warning",
      confirmButtonText: "Yes",
      confirmButtonColor: "green",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      icon: 'warning'
    }).then((res) => {
      if (res.isConfirmed) {
        setLoading(true);
        var config = {
          method: 'delete',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.DeleteOperation,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': authHeader(),
            'CypherRepeclia': Crypter.encrypt(NUMRAP),
            'CypherCodeA': Crypter.encrypt(user.codage),
            'CypherCodeU': Crypter.encrypt(user.coduti),
            'CypherRepec': Crypter.encrypt(Reference)
          }
        }

        axios(config)
          .then((response) => {
            //alert('ok')
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
              if (res.StatutCode == 200) {
                let datas = res.Result[0];
                if (datas.length === 0) {

                }
                else {
                  SweetAlert.fire({ title: datas.Column1, text: 'reference:' + Reference, icon: "success" });
                 
                  props.GetAllOperation(Reference);
                }
              }
              else SweetAlert.fire({ title: 'Error ', text: res.Message, icon: "error" });
              setLoading(false);
            }
            //  setLoad(false);
          }).catch((error) => {
            setLoading(false);
            SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
          })
      };
    })
      .catch((error) => {
        setLoading(false);
        console.log(error)
        SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
      });

    setLoading(false);

  }



  return (
    <div className='tabItem' >
      <div >
 

  <Box fontStyle="inherit" className='bordure1'  width={"85%"} position={"absolute"} sx={{p:1}}>
    <Box className='bordure1'  >
  {/* Ligne 1 : Inputs d'information */}
  <Grid container spacing={2}>
    <Grid item xs={3} >
      {/* <Form.Item  name={informationclient.InputDisponible.name} style={{ marginBottom: 0 }}> */}
        <InputFormMUI
        money
        icon={<MonetizationOnOutlined />}
        //width={9}
        disabled
        label={informationclient.InputDisponible.label}
        name={informationclient.InputDisponible.name}
        type='text'
        value= {props.form.getFieldValue("DISPON") }
      />
     {/* </Form.Item> */}
    </Grid>
    <Grid item xs={3}>
        {/* <Form.Item name={informationclient.InputVeille.name} style={{ marginBottom: 0 }}> */}
         <InputFormMUI
        money
        icon={<NightShelterOutlined />}
        disabled
        //width={9}
        label={informationclient.InputVeille.label}
        name={informationclient.InputVeille.name}
        type='number'
        value={props.form.getFieldValue("SOLVEI")}
      />
        {/* </Form.Item> */}
      
    </Grid>
    <Grid item xs={3}>
      {/* <Form.Item  name={informationclient.InputBloque.name} style={{ marginBottom: 0 }}> */}
        <InputFormMUI
        money
        icon={<BlockOutlined />}
        //width={10}
        disabled
        label={informationclient.InputBloque.label}
        name={informationclient.InputBloque.name}
        type='number'
        value={props.form.getFieldValue("BLOQUE")}
      />
     {/* </Form.Item> */}
      
    </Grid>
    <Grid item xs={3}>
      {/* <Form.Item  name={informationclient.InputAutori.name} style={{ marginBottom: 0 }}> */}
       <InputFormMUI
        money
        icon={<BlockOutlined />}
        //width={9}
        disabled
        label={informationclient.InputAutori.label}
        name={informationclient.InputAutori.name}
        type='number'
        value={props.form.getFieldValue("AUTORI")}
      />
      {/* </Form.Item> */}
      
    </Grid>
  </Grid>
</Box>

<Box  className='bordure1' mt={1}>
  {/* Ligne 2 : Search Reference */}
  <Grid container spacing={1}>
    <Grid item xs={12}>
      <SearchModalMUI
        notremove
        disabledCode={props.etatG}
        disabledLibell={true}
        width={250}
        Titre={informationclient.SearchRef.Titre}
        label={informationclient.SearchRef.label}
        name={informationclient.SearchRef.name}
        Parametre={informationclient.SearchRef.params}
        form={props.form}
      />
    </Grid>
  </Grid>

  {/* Ligne 3 : Compte + Devise */}
  <Grid container spacing={1} mt={0}>
    <Grid item xs={8}>
      <SearchModalMUI
        width={300}
        handleFunction={handleChangeCompte}
        form={props.form}
         disabledCode={false}
        disabledLibell={true}
        Titre={informationclient.searchCompte.Titre}
        label={informationclient.searchCompte.label}
        name={informationclient.searchCompte.name}
        Parametre={informationclient.searchCompte.params}
      />
    </Grid>
    <Grid item xs={4}>
      <SearchModalMUI
       // width={200}
        form={props.form}
        disabledCode={true}
        disabledLibell={true}
        Titre="Recherche devise"
        label="Devise"
        name="CDDEVS"
        Parametre={informationclient.searchCompte.params}
      />
    </Grid>
  </Grid>

  {/* Ligne 4 : Code Opération + Sens */}
  <Grid container spacing={1} mt={0}>
    <Grid item xs={12}>
      
      <SearchModalMUI
        width={150}
        form={props.form}
        //disabled
         disabledCode={false}
        disabledLibell={false}
        Titre={informationclient.searchCodeOpe.Titre}
        label={informationclient.searchCodeOpe.label}
        name={informationclient.searchCodeOpe.name}
        Parametre={informationclient.searchCodeOpe.params}
        
      />
    
    </Grid>
   
  </Grid>

  {/* Ligne 5 : Montant + Taux + Référence */}
  <Grid container spacing={1} mt={0} >
    <Grid item xs={3}>
      <SelectOptionMUI 
      form={props.form}
      disabled={false}
      Size='small'
        name="Sence"
        Option={dataOption2}
        //width={200}
        //form={props.form}
        label="Sens"
      />

     
      {/* <Form.Item name="Sence" style={{ marginBottom: 0 }} rules={[{ required: true, message: 'Champ requis' }]}>
        <FormControl fullWidth size="small">
          <InputLabel id="select-sens-label"
           sx={{ fontWeight: 'bold',fontSize: '20px' }}
          >Sens</InputLabel>
          <Select
            labelId="select-sens-label"
            label="Sens"
            value={props.form?.getFieldValue("Sence") ?? ''}
            onChange={(e) => props.form?.setFieldsValue({ Sence: e.target.value })}
            displayEmpty
            renderValue={(selected) => {
              if (!selected) return <em></em>;
              const opt = dataOption2.find((o) => o.value === selected);
              return opt ? opt.label : selected;
            }}
             variant="outlined"
      sx={{ width: '100%', borderRadius:1,
        '& .MuiInputLabel-root': {
      fontWeight: 'bold',
      fontSize: '18px',
    }
       }}
          >
            <MenuItem value="">
              <em>Sélectionner...</em>
            </MenuItem>
            {dataOption2.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Form.Item> */}
        
    </Grid>
    <Grid item xs={3}>
      {/* <Form.Item name={informationclient.InputMontant.name} style={{ marginBottom: 0 }}> */}
        <InputFormMUI
       // width={6}
        money
        icon={<AttachMoneyOutlined />}
        label={informationclient.InputMontant.label}
        name={informationclient.InputMontant.name}
        type='number'
        //value={props.form.getFieldValue("Montant")}
        //value={0}
      />
     
      {/* </Form.Item> */}
    </Grid>
    <Grid item xs={3}>
      {/* <Form.Item name={informationclient.InputTaux.name} style={{ marginBottom: 0 }}> */}
        <InputFormMUI
         money
        icon={<AdminPanelSettingsOutlined />}
       // defaultValue={1}
        disabled
       // width={7}
        label={informationclient.InputTaux.label}
        name={informationclient.InputTaux.label}
        type='number'
        //value={1}
      />
      {/* </Form.Item> */}
      
    </Grid>
    <Grid item xs={3}>
      {/* <Form.Item name="RefManuel" style={{ marginBottom: 0 }}> */}
       <InputFormMUI
        label="Référence pièce"
        name='RefManuel'
        type='text'
      />
     
     
    </Grid>
  </Grid>
</Box>
          <Box className='bordure1'>
            <Table sticky={true} columns={columns} size='small' style={{ width: '100%' }} pagination={false} scroll={{ y: 250, x: 1200 }} dataSource={props.DataOperation} />
          </Box>
          <Box display={"flex"} width={"98%"} marginTop={"5px"} fontStyle="inherit">
          <Grid container spacing={2}>
           <Grid item xs={3} >
                  <InputFormMUI
                  disabled
                  label="Total Crédit"
                  name='TotalCrebitOP'
                  type='text'
                  />
          </Grid>
          <Grid item xs={1.5} >
                  <InputFormMUI
                  disabled
                  label="Nombre crédit"
                  name='NbrCrebitOP'
                  type='text'
                  />
          </Grid>
          <Grid item xs={3} >
                  <InputFormMUI
                  disabled
                  label="Total Débit"
                  name='TotalDebitOP'
                  type='text'
                  />
          </Grid>
          <Grid item xs={1.5} >
                  <InputFormMUI
                  disabled
                  label="Nombre débit"
                  name='NbrdebitOP'
                  type='text'
                  />
          </Grid>
           <Grid item xs={3} >
                  <InputFormMUI
                  disabled
                  label="Balance"
                  name='SoldeOP'
                  type='text'
                  />
          </Grid>
          

      </Grid>

            {/* <Space.Compact >
              <Form.Item style={{ width: '70%' }} label="Total Crédit / Nombre crédit" name='TotalCrebitOP'><Input disabled /></Form.Item>
              <Form.Item style={{ width: '14%' }} name='NbrCrebitOP'><Input disabled /></Form.Item>
            </Space.Compact>
            <Space.Compact >
              <Form.Item style={{ width: '70%' }} label="Total Débit / Nombre débit" name='TotalDebitOP'><Input disabled /></Form.Item>
              <Form.Item style={{ width: '14%' }} name='NbrdebitOP'><Input disabled /></Form.Item>
            </Space.Compact>
            <Space.Compact >
              <Form.Item label="Solde Total" name='SoldeOP'><Input disabled /></Form.Item>
            </Space.Compact> */}
          </Box>
   </Box>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  );

}
export default Tab1;
